import { getApi } from "../../services/api";

export const logout = () => getApi("/admin/logout");
